const copy = {
  preChat: {
    headerText: "How can I help?",
    secondaryHeaderText: "Ask our Sales Co-Pilot!",
  },
};

export default copy;
